/* eslint-disable complexity */
/* eslint-disable react/prop-types */
import { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify'
import * as userActions from '../actions/userActions'

import '../assets/styles/components/App.scss'

import LoadingBar from 'react-redux-loading-bar'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import CommunityBlockModal from './common/CommunityBlockModal'
import CommunityChooser from './communities/CommunityChooser/CommunityChooser'
import { getActiveCommunity, requiresCommunityChoice } from '../utility/activeCommunity'
import { applyLocale, resolveLocale } from '../utility/localeHelper'
import { Outlet } from 'react-router-dom'
import { withRouting } from './common/hooks'
import { initializePendo, syncPendoSkip } from '../utility/pendo'
import { startIntercom } from '../utility/intercom'
import { loadGgMenuScript } from '../actions/ggMenuActions'
import ExpandableSideBar from './common/SideBar/ExpandableSideBar'
import Loader from './common/loader/legacy-loaders/Op36Loader-web'

class AppWrapper extends Component {
  state = {
    showCommunityBlockModal: false,
    embed: localStorage.getItem('embed'),
  }

  userLocale() {
    return this.props.user?.user_settings?.locale || getActiveCommunity(this.props.user, this.props.activeCommunityId)?.locale
  }

  componentDidMount() {
    const { user } = this.props

    syncPendoSkip(window.pendo, this.props.consents, this.props.isImpersonating, this.state.showCommunityBlockModal)

    if (user) {
      const communityId = localStorage.getItem('communityId')
      this.props.user_actions.refreshCurrentUser(user.id, communityId).then((response) => {
        applyLocale(resolveLocale(this.userLocale()))
        initializePendo(window.pendo, user, this.props.activeCommunityId)

        localStorage.removeItem('communityId')
        if (response.data?.invitation_feedback?.status) {
          this.props.navigate('/dashboard/programs', { replace: true })
        }

        if (response.data?.invitation_feedback?.status === 'accepted') {
          toast.success(response.data?.invitation_feedback?.message)
        } else if (response.data?.invitation_feedback?.status === 'rejected') {
          toast.error(response.data?.invitation_feedback?.message)
        }

        if (user.type === 'Coach') {
          startIntercom(user)
        }

        if (user.type === 'Admin' || user.type === 'Coach') {
          loadGgMenuScript()
        }
      })
    }

    localStorage.removeItem('embed')
  }

  componentDidUpdate(prevProps) { // TODO: Check this, replaced componentWillReceiveProps
    const { user, activeCommunityId } = this.props

    syncPendoSkip(window.pendo, this.props.consents, this.props.isImpersonating, this.state.showCommunityBlockModal)

    // Re-identify on community switch too: that only changes activeCommunityId, not the user object
    if (user && (user.id !== prevProps.user?.id || activeCommunityId !== prevProps.activeCommunityId)) {
      initializePendo(window.pendo, user, this.props.activeCommunityId)
    }

    if (!this.props.user || this.props.user === prevProps.user) {
      return
    }

    applyLocale(resolveLocale(this.userLocale()))

    if (!window.pendo) {
      // eslint-disable-next-line no-console
      console.log('no pendo')
    }

    if (
      this.props.user &&
      this.props.user.type !== 'Admin' &&
      this.props.user.communities &&
      this.props.user.communities.length > 0
    ) {
      this.checkActiveCommunity(this.props.user)
    }

    if (this.props.user && this.props.user.type === 'Coach') {
      if (window.$zopim && window.$zopim.livechat) {
        window.$zopim.livechat.button.show()
      }
      if (
        window.$zopim &&
        window.$zopim.livechat &&
        window.$zopim.livechat.button
      ) {
        window.$zopim.livechat.button.setOffsetHorizontal(65)
        window.$zopim.livechat.window.setOffsetHorizontal(65)
      }
    } else if (this.props.user && this.props.user.type === 'Student') {
      if (window.$zopim && window.$zopim.livechat) { window.$zopim.livechat.hideAll() }
    } else if (this.props.user && this.props.user.type === 'Admin') {
      if (window.$zopim && window.$zopim.livechat) { window.$zopim.livechat.hideAll() }
    }
  }

  checkActiveCommunity = (user) => {
    const { location } = this.props
    const COMMUNITY_INACTIVE = user.communities.length > 0 && !user.communities.some((community) => community.is_active)

    if (
      (user.type === 'Coach' || user.type === 'Student') &&
      COMMUNITY_INACTIVE &&
      location.pathname !== '/login/legacy'
    ) { this.launchCommunityBlockModal() }

    if (location.pathname === '/login/legacy') { this.closeCommunityBlockModal() }
  }

  launchCommunityBlockModal = () => {
    this.setState({ showCommunityBlockModal: true })
  }

  closeCommunityBlockModal = () => {
    this.setState({ showCommunityBlockModal: false })
  }

  showNav = () => {
    if ((!this.props.ui.showNavBar && !this.props.ui.showTabBar) || this.props.user.type === 'Student') {
      return 'no-nav'
    } else {
      return ''
    }
  }

  render() {
    const { embed } = this.state
    const { user } = this.props

    if (user?.type === 'Student' && requiresCommunityChoice(user, this.props.activeCommunityId)) {
      return <CommunityChooser user={user} />
    }

    return (
      <div className='content'>
        <div className='App'>
          {embed ? (
            <Loader />
          ) : (
            <>
              {this.props.user.type !== 'Student' && (
                <ExpandableSideBar />
              )}

              <div id='appWebBody' className={this.showNav()}>
                <LoadingBar
                  className='loading-bar'
                  updateTime={50}
                  maxProgress={95}
                  progressIncrease={10}
                  showFastActions
                />
                <div className='container-fluid'>
                  <Outlet />
                </div>
              </div>

              <CommunityBlockModal
                showModal={this.state.showCommunityBlockModal}
                closeModal={this.closeCommunityBlockModal}
              />
            </>
          )}
        </div>
        <ToastContainer theme='colored' style={{ zIndex: 9999999 }}/>
      </div>
    )
  }

}

AppWrapper.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    created_at: PropTypes.string,
    intercom_hash: PropTypes.string,
    user_type: PropTypes.string,
    lead_coach: PropTypes.bool,
    communities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      license_type: PropTypes.string,
      representative_name: PropTypes.string,
      student_count: PropTypes.number,
      created_at: PropTypes.string,
    })),
  }),
}

function mapStateToProps(state, _ownProps) {
  return {
    user: state.user.current_user,
    activeCommunityId: state.user.active_community_id,
    consents: state.consents,
    isImpersonating: state.user.is_impersonating,
    isLoading: state.loading.isLoading,
    ui: state.ui,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    user_actions: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouting(AppWrapper))
